<!-- 坤元基金用户隐私保护政策 -->
<template>
  <div class="agreement userPrivacyAgrement" v-html="articleContent"></div>
</template>
<script src="@/assets/js/tinymce.min.js" referrerpolicy="origin"></script>
<script>
import api from '@/api'
export default {
  data() {
    return {
      articleContent: '',
    }
  },
  async mounted() {
    const { data } = await api.getUserPrivacyAgrement()
    this.articleContent = data.data.article
  },
}
</script>
<style lang="stylus">
@import './index.styl'
</style>
<style lang="stylus">
.userPrivacyAgrement {
  width 100%;
  box-sizing border-box;
  padding: 60px 40px 40px 40px !important;
  text-align left;
  p {
    line-height: 50px;
  }
  table {
  display block;
  box-sizing border-box;
  max-width calc(100% - 90px);
  overflow-x auto;
  overflow-y hidden;
  margin-bottom 10px !important;
  }
}
</style>
